<template>
  <COffcanvas
    :visible="$cartStore.cartVisible"
    placement="end"
    :backdrop="true"
    :keyboard="true"
    @show="$cartStore.showCart"
    @hide="$cartStore.hideCart">
    <COffcanvasHeader class="border-bottom">
      Welcome {{ $account.customerName }}
      <CDropdown v-if="$account.isLoggedIn" class="ms-2 dropdown-account">
        <CDropdownToggle size="sm" class="btn-account">
          Account
        </CDropdownToggle>
        <CDropdownMenu>
          <CDropdownItem href="/account" @click="$cartStore.hideCart">My Account</CDropdownItem>
          <CDropdownDivider/>
          <CDropdownItem @click="$account.logout">Sign out</CDropdownItem>
        </CDropdownMenu>
      </CDropdown>
      <template v-else>
        <span class="ms-2 text-small">
          <a class="text-ss-iris btn-outline-grey btn btn-sm" href=""
            @click.prevent="showLogin">Sign in
          </a>
        </span>
      </template>
      <CCloseButton class="text-reset"
        @click="$cartStore.hideCart"
      />
    </COffcanvasHeader>
    <COffcanvasBody>
      <cart-product-list />
    </COffcanvasBody>
    <div class="sidePanelFooter pb-3 border-top flex-grow-0 flex-shrink-1 d-flex flex-column align-items-center" style="text-align: right">
      <div class="d-flex flex-row w-75 mt-2 gap-1">
        <div class="d-flex flex-grow-1 justify-content-end text-ss-grey-dark">
          Subtotal
        </div>
        <div class="w-25 justify-content-end">
          {{ $cartStore.subtotal }}
        </div>
      </div>
      <div v-for="(discount, i) of $cartStore.cartDiscounts" :key="i"
        class=" d-flex flex-row text-small w-75 gap-1">
        <div class="d-flex flex-grow-1 align-items-center justify-content-end text-ss-grey-dark">
          <i class="fa fa-tag me-1"></i>{{ discount.description }}
        </div>
        <div class="w-25 justify-content-end">
          {{ discount.formattedAmount }}
        </div>
      </div>
      <div v-if="$cartStore.cartDiscounts.length" class="d-flex flex-row w-75 gap-1">
        <div class="d-flex flex-grow-1 justify-content-end text-ss-grey-dark">
          Discounted Subtotal
        </div>
        <div class="w-25 justify-content-end">
          {{ $cartStore.discountedSubtotal }}
        </div>
      </div>
      <a class="btn btn-secondary w-75 mt-2" href="/cart/" @click="$cartStore.hideCart">
        <i class="fa-duotone fa-cart-shopping-fast pe-2"></i>
        Checkout
      </a>
    </div>
  </COffcanvas>
</template>

<script lang="ts">
  export default {
    name: 'CartPanel',
    inheritAttrs: false,
    customOptions: {}
  }
</script>
<script lang="ts" setup>

import CartProductList from './cartProductList.vue';
import { CCloseButton } from '@coreui/bootstrap-vue/src/components/close-button/CCloseButton';
import {
  COffcanvas,
  COffcanvasBody,
  COffcanvasHeader,
} from '@coreui/bootstrap-vue/src/components/offcanvas/index';
import {
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CDropdownDivider,
} from '@coreui/bootstrap-vue/src/components/dropdown/index';
import { CButton } from '@coreui/bootstrap-vue/src/components/button/index';

import { useCartStore } from './cartStore';
import { useAccountStore } from '../account/accountStore';
import { watch } from 'vue';

const $account = useAccountStore();
const $cartStore = useCartStore();

function showLogin() {
  $cartStore.hideCart();
  $account.showLogin();
}

watch(() => $account.isLoggedIn, (isLoggedIn) => {
  if (isLoggedIn) {
    window.current_user = $account.customerName;
    if (window._userMessage?.html) {
      window._userMessage.element.innerHTML = window._userMessage.html;
    }
  } else {
    window.current_user = void 0;
  }
});

</script>

<style lang="scss" scoped>
.text-small { font-size: 90%; }

// bs-success-dark, but can't use the variable for whatever reason and I gave up trying
.btn-account.show { --bs-btn-active-color: #17592b; }
.btn-account.show:hover { --bs-btn-active-bg: rgba(var(--bs-primary-rgb), 0.15); }
.btn-account.dropdown-toggle::after { margin-bottom: -2px; }
.dropdown-menu .dropdown-item { cursor: pointer; }
</style>